export default __webpack_public_path__ + "closeCollapsible.05377623.png";